/** 与中文界面原文完全一致的已有 workbench 词条。 */
export const FIXED_UI_KEYS = {
  "关闭": "agentHome.historyCloseShort",
  "请先选择店铺": "tiktokEmpty.pickShopTitle",
  "取消": "shop.cancel",
  "款号": "productTemplate.colStyleNo",
  "操作": "shop.colActions",
  "批量查询": "tiktokCatalog.batchQuery",
  "备注": "shop.remark",
  "优先级": "productTemplate.colPriority",
  "自动规则": "productTemplate.colAutoRule",
  "复制失败": "productTemplate.copyFailed",
  "适用类目": "rrpLib.categoryApply",
  "状态": "shop.colStatus",
  "产品信息": "productTable.productInfo",
  "模板名称": "productTemplate.colName",
  "请选择": "shop.pleaseSelect",
  "站点": "productTable.site",
  "建议零售价": "platformHome.shein.rrp",
  "加载中…": "agentHome.loading",
  "暂无可导出数据": "rrpOps.noneExport",
  "加载失败": "agentHome.loadFailed",
  "经营数据": "platformNav.businessData",
  "编辑": "draftBox.edit",
  "导出数据": "tiktokList.exportData",
  "导出中…": "tiktokList.exporting",
  "导出筛选": "tiktokList.exportFiltered",
  "导出本页": "tiktokList.exportPage",
  "导出选中": "tiktokList.exportSelected",
  "批量操作": "tiktokList.batchOps",
  "批量删除": "tiktokList.batchDelete",
  "批量拒绝": "rrpOps.batchReject",
  "全部": "tiktokCatalog.all",
  "已上架": "tiktokCatalog.listed",
  "待上架": "tiktokCatalog.pending",
  "已售罄": "tiktokCatalog.soldOut",
  "已下架": "tiktokCatalog.offline",
  "待审核": "publishRecord.tabPendingReview",
  "更多": "productTable.more",
  "可选": "photoLib.optional",
  "已复制": "freightLib.copied",
  "已开始下载": "marketing.enDownloadStarted",
  "点击上传": "photoLib.clickUpload",
  "尺码": "sizeChartPanel.sizeCol",
  "店铺信息": "shop.colInfo",
  "商家 ID": "shop.supplierId",
  "今日已达上限": "tiktokList.quotaExhausted",
  "拉取 TikTok 后台数据": "tiktokList.pull",
  "拉取 TEMU 后台数据": "productTable.pullTemu",
  "拉取 SHEIN 后台数据": "productTable.pullShein",
  "关键词": "productTemplate.keyword",
  "请填写模板名称": "compliance.lbNeedTplName",
  "暂无数据": "orderList.emptyData",
  "尺寸": "sizeChartPanel.sizeWord",
  "开始": "workflowStart",
  "结束": "workflowEnd",
  "请选择类目": "rrpLib.needCategory",
  "币种": "returnDetail.currency",
  "货号": "draftBox.supplier",
  "批量输入货号": "tiktokCatalog.batchInputSupplier",
  "类型": "draftBox.type",
  "上传中": "photoLib.uploading",
  "移除": "productCopy.remove",
  "尺寸信息": "sizeChartPanel.sectionTitle",
  "请填写款号": "templateEditor.fillStyle",
  "请输入款号": "saveTpl.stylePh",
  "暂无数据可导出": "brandLib.nothingToExport",
  "暂无场次": "marketing.enNoSessions",
  "活动名称": "marketing.enActName",
  "名称": "certList.name",
  "选择要同步的店铺": "tiktokCatalog.pickSyncShop",
  "请先勾选要导出的数据": "brandLib.pickExport",
  "类目": "productTemplate.colCategory",
  "正在加载模板…": "photoLib.loadingTemplate",
  "批量输入 SKC": "rrpOps.batchSkcAria",
  "标题": "productTable.title",
  "站点 ID": "marketing.enSiteId",
  "报名方式": "marketing.enEnrollWay",
  "请先勾选数据": "stock.pickRows",
  "报名截止": "marketing.enDeadline",
  "全选": "productTemplate.selectAll",
  "请先选择规格尺码": "publishPkg.pickSizeFirst",
  "共用": "sizeChartPanel.shared",
  "价格": "platformNav.price",
  "平台 JSON": "syncedLib.platformJson",
  "暂无可发商品分类": "productTemplate.noCategories",
  "店铺": "productTable.shop",
  "请先选择已授权的 TikTok 店铺": "brandLib.pickTiktokShop",
  "产品ID": "tiktokCatalog.productId",
  "审核状态": "rrpOps.auditStatus",
  "规则无效": "compliance.badRule",
  "自动规则已保存": "rrpOps.saved",
  "商家货号，支持批量": "rrpOps.supplierPh",
  "来源": "sizeChart.source",
  "时间": "productTable.time",
  "分类": "finance.category",
  "说明": "compliance.lbNote",
  "活动时间": "marketing.enActTime",
  "场次": "marketing.enSession",
  "加载场次中…": "marketing.enLoadingSessions",
  "不限": "tiktokPublish.unlimited",
  "供货价": "productTable.supplyPrice",
  "请先选择 TikTok 店铺": "finance.pickTiktok",
  "申请新增属性值": "publishExtra.applyTitle",
  "属性值": "publishExtra.attrValue",
  "裁剪中": "publishImg.cropping",
  "产品尺寸信息": "sizeChartPanel.title",
  "选择尺码库": "sizeChartPanel.pickLib",
  "SKU 明细": "rrpOps.skuDetail",
  "商家 SKU": "publishSpec.merchantSku",
  "正在查询建议零售价填写规则…": "publishExtra.rrpLoading",
  "分站点建议零售价": "publishExtra.bySiteRrp",
  "本站无需证明材料": "publishExtra.noProof",
  "其他站点建议零售价（不分站点汇总）": "publishExtra.otherSiteRrp",
  "其他站点无需证明材料": "publishExtra.otherNoProof",
  "侵权检测结果": "publishSpec.riskTitle",
  "检测状态：": "publishSpec.riskStatus",
  "检测时间：": "publishSpec.riskTime",
  "暂无详细检测说明": "publishSpec.riskEmpty",
  "将应用到当前所有 SKU 行": "publishSpec.applyAllRows",
  "颜色编码": "publishSpec.colorCode",
  "暂无已选颜色": "publishSpec.noColors",
  "视频": "commerce.video",
  "当前": "tiktokSwitch.current",
  "最新": "publishAttr.latest",
  "清空": "publishAttr.clear",
  "上传类型": "publishExtra.uploadType",
  "图片预览": "agentHome.preview",
  "点击预览大图": "photoLib.previewClick",
  "品牌名称": "brandLib.colBrandName",
  "可发类目": "shop.colCategories",
  "店铺名称": "shop.shopName",
  "授权状态": "shop.colAuth",
  "基本信息": "compliance.basic",
  "文件名称": "certLib.fileNameLabel",
  "展示用文件名": "certForm.fileNamePh",
  "证书文件": "certLib.colFiles",
  "已上传证书文件": "certLib.uploadedAria",
  "类目属性尚未加载完成，请稍后再保存": "templateEditor.attrsNotReady",
  "如：女装夏季基础属性": "saveTpl.namePhAttr",
  "当前类目暂无可填属性": "publishAttr.none",
  "保存到官方属性库": "saveTpl.saveOfficialAttr",
  "保存到属性库": "saveTpl.saveAttr",
  "保存产品模板": "saveTpl.saveProduct",
  "保存到官方尺码库": "saveTpl.saveOfficialSize",
  "折扣": "marketing.enDiscount",
  "暂无可报商品": "marketing.enNoReportGoods",
  "货号，支持逗号批量": "tiktokCatalog.supplierPlaceholder",
  "品牌": "tiktokCatalog.brand",
  "请先选择已授权的 TEMU 店铺": "returnList.semiPickShop",
  "请先选择 TEMU 店铺": "marketing.pickTemu",
  "物流商": "orderList.carrier",
  "运单号": "orderList.waybillNo",
  "按供货价折扣": "marketing.enByDiscount",
  "按统一报价": "marketing.enByPrice",
  "持续天数": "marketing.enDuration",
  "场次状态": "marketing.enSessionStatus",
  "报名状态": "marketing.enrollStatus",
  "报名向导": "marketing.enWizard",
  "报名步骤": "marketing.enSteps",
  "全选当前页场次": "marketing.enSelectPageSessions",
  "已按当前活动与所选货品查询场次列表。": "marketing.enSessionsHint",
  "全选当前页站点": "marketing.enSelectPageSites",
  "站点名称": "marketing.enSiteName",
  "暂无可选站点": "marketing.enNoSites",
  "商品 ID": "marketing.enGoodsId",
  "订单": "finance.order",
  "件数": "publishPkg.phQty",
  "备货发货": "platformHome.stockShip",
  "打印中心": "platformNav.printCenter",
  "包装合规": "platformNav.packing",
  "商品广告": "platformNav.ads",
  "销量数据": "platformNav.salesVolume",
  "加载详情中…": "marketing.enLoadingDetail",
  "是否可报名": "marketing.enCanEnroll",
  "暂无详情": "marketing.enNoDetail",
  "活动库存": "marketing.enActStock",
  "活动状态": "marketing.statusAria",
  "活动场次": "marketing.enSessionsTitle",
  "单号": "finance.docNo",
  "是": "orderList.yes",
  "否": "orderList.no",
  "重量": "publishPkg.weight",
  "SKU 分类": "publishPkg.skuClass",
  "单品数量": "publishPkg.pieceQty",
  "共计内含": "publishPkg.totalContains",
  "独立包装": "publishPkg.indep",
  "是否敏感": "publishPkg.sensitiveQ",
  "请先选择规格颜色与尺码": "publishPkg.pickColorSize",
  "可先填一套模板再同步到各尺码": "publishPkg.fillTemplate",
  "按尺码填写": "publishSpec.fillBySize",
  "图案编号": "publishSpec.patternNo",
  "在商家 SKU 添加图案编号": "publishSpec.addPatternToSku",
  "正在查询该类目是否必须上传说明书…": "publishExtra.guideChecking",
  "更新说明书文件": "publishExtra.intentUpdate",
  "补充或修改【安装/使用说明】和【安全信息说明】": "publishExtra.intentSupplement",
  "说明书尽可能覆盖更多语言，可有效提升转化并降低客诉。": "publishExtra.guideNote",
  "模特": "modelLib.model",
  "请先选择类目": "sizeChartPanel.pickCategory",
  "该类目无需填写尺码表。": "sizeChartPanel.notNeeded",
  "正在加载尺码表": "sizeChartPanel.loadingTitle",
  "请从上方尺码表库选择": "sizeChartPanel.pickFromLibAbove",
  "搜索": "agentHome.tabSearch",
  "仓库": "stock.colWarehouse",
  "运费模板": "tiktokPublish.freight",
  "预览": "agentHome.previewAction",
  "上一步": "shop.backStep",
  "品牌 ID": "brandLib.colBrandId",
  "店铺类型": "shop.shopType",
  "已删除": "shop.deleted",
  "模板名称，支持模糊": "rrpLib.nameFilterPh",
  "更新时间": "productTemplate.colUpdatedAt",
  "请至少上传一个证书文件": "certForm.needOneFile",
  "证书类型": "certLib.colType",
  "该类目缺少 product_type_id，无法查询属性，请换一个末级类目": "sizeCreate.missingTypeLeaf",
  "保存为尺码模板": "saveTpl.saveAsSize",
  "测量类型": "sizeChartPanel.measureType",
  "单位制": "sizeChartPanel.unitSystem",
  "平台 SKC，支持批量": "rrpOps.skcPh",
  "报名时间": "marketing.enEnrollTime",
  "权益说明": "marketing.enRights",
  "调整价": "marketing.enAdjustPrice",
  "涨价原因": "publishExtra.riseReason",
  "暂无可导出的商品": "tiktokCatalog.nothingToExport",
  "当前页没有可导出的商品": "tiktokCatalog.pageEmptyExport",
  "请先勾选要导出的商品": "tiktokCatalog.pickExport",
  "未删除任何缓存（可能已删除或不存在）": "orderList.noneDeleted",
  "产品状态": "tiktokCatalog.statusAria",
  "当前店铺正在同步中，请等待同步完成后可操作": "tiktokCatalog.syncBusy",
  "编码类型": "tiktokCatalog.idTypeAria",
  "品牌，支持逗号批量": "tiktokCatalog.brandPlaceholder",
  "批量输入品牌": "tiktokCatalog.batchInputBrand",
  "同步入口未就绪，请稍后重试": "tiktokCatalog.syncNotReady",
  "请选择证书类型": "certForm.pickType",
  "正在加载尺码表规则…": "templateEditor.sizeChartLoading",
  "售价": "productTable.salePrice",
  "合规资料": "commerce.featureComplianceTitle",
  "影响站点": "compliance.lbColSites",
  "近 7 天": "orderList.last7d",
  "查询": "shop.query",
  "请先选择具体店铺": "syncedLib.pickConcrete",
  "优惠": "marketing.enOffer",
  "已用": "marketing.enUsed",
  "活动里还没有商品": "marketing.enNoActGoods",
  "加载活动商品中…": "marketing.enLoadingGoods",
  "展示": "marketing.cpDisplay",
  "活动报名": "marketing.enPageTitle",
  "商品": "orderList.product",
  "主规格": "productTable.mainSpec",
  "直接折扣": "marketing.ttsDIRECT_DISCOUNT",
  "固定价格": "marketing.ttsFIXED_PRICE",
  "秒杀": "marketing.ttsFLASHSALE",
  "运费折扣": "marketing.ttsSHIPPING_DISCOUNT",
  "创建中…": "brandLib.creating",
  "创建": "shop.create",
  "保存中…": "tiktokPublish.saving",
  "保存": "shop.save",
  "提交中…": "tiktokPublish.submitting",
  "长": "publishPkg.len",
  "宽": "publishPkg.wid",
  "高": "publishPkg.hei",
  "批量填写商品条码": "publishSpec.batchBarcode",
  "默认填写": "publishSpec.fillDefault",
  "条码类型": "publishSpec.barcodeType",
  "商品条码": "publishSpec.barcode",
  "同一条码将写入当前所有颜色 / 尺码 SKU": "publishSpec.barcodeAllHint",
  "暂无已选尺码": "publishSpec.noSizes",
  "同一尺码下的各颜色 SKU 共用该条码；未填的尺码不改动": "publishSpec.barcodeSizeHint",
  "注册商号": "compliance.euTrade",
  "邮箱": "compliance.euEmail",
  "国家码": "compliance.euCountryCode",
  "本地号码": "compliance.euLocalNo",
  "地址": "compliance.euAddress",
  "有效期": "rrpOps.validity",
  "请至少选择一张图片": "photoLib.pickOne",
  "所选图片无效或已失效，请重试": "photoLib.invalidImages",
  "请先选择参考店铺以加载尺码表填写规则": "sizeChartPanel.needRefShop",
  "正在拉取测量项与尺码库，请稍候…": "sizeChartPanel.loadingHint",
  "创建尺码表": "sizeChartPanel.createChart",
  "上传图片": "sizeChartPanel.uploadImage",
  "请先选择店铺后再上传尺码表图片。": "sizeChartPanel.pickShopImage",
  "确认测量参数": "sizeCreate.confirmMeta",
  "未绑定类目：按已有结构化内容编辑；保存后建议同步以回填类目。": "sizeChartPanel.unbound",
  "正在加载类目尺码规则…": "sizeChartPanel.loadingCatRules",
  "该类目不支持尺码表（平台 is_supported=false）。": "sizeChartPanel.unsupported",
  "已选均码，不可再选其它尺码；清除后可多选。": "sizeChartPanel.oneSizeLocked",
  "半托管": "shopTypeLabel.semi",
  "上传中…": "publishExtra.uploading",
  "正在加载详情…": "marketing.cpLoadingDetail",
  "是否可报": "marketing.enCanReport",
  "提报维度": "marketing.enDim",
  "报价形式": "marketing.enQuote",
  "填报项": "marketing.enFields",
  "可选站点": "marketing.enOptSites",
  "供货价币种": "marketing.enCurrency",
  "锁价说明": "marketing.enLock",
  "最大提报数": "marketing.enMaxReport",
  "关联活动": "marketing.enLinked",
  "店铺要求": "marketing.enShopReq",
  "商品要求": "marketing.enGoodsReq",
  "活动介绍": "marketing.enIntro",
  "报名站点": "marketing.enEnrollSites",
  "活动件数": "marketing.pf2",
  "预留件数": "marketing.enReserve",
  "库存 / 规则": "marketing.enStockRule",
  "正在拉取平台可报商品…": "marketing.enPulling",
  "SKU 价格明细": "marketing.enSkuPrices",
  "暂无 SKU 价格信息": "marketing.enNoSkuPrice",
  "批量填写": "marketing.enBatchFill",
  "尺寸单位": "publishPkg.dimUnit",
  "重量单位": "publishPkg.weightUnit",
  "批量填写商家 SKU": "publishSpec.batchMerchantSku",
  "印花图名称": "publishSpec.printName",
  "商品视频": "publishSpec.productVideo",
  "品牌编码": "compliance.brandCode",
  "英文名称": "publishBasic.titleEn",
  "已授权": "shop.authConnected",
  "请先选择证书类型": "certLib.needType",
  "该证书类型没有填写模板可下载": "certLib.noDownload",
  "请先同步并选择证书类型编码": "certLib.needSyncedType",
  "检测机构": "certLib.agency",
  "请选择检测机构": "certLib.pickAgency",
  "实验室": "certLib.lab",
  "请选择实验室": "certLib.pickLab",
  "请选择日期时间": "certLib.pickDateTime",
  "适用范围": "certLib.colScope",
  "部分商品（需手动绑定 SKC）": "certLib.scopePartial",
  "全部商品（自动绑定现有及后续商品）": "certLib.scopeAll",
  "证书类型编码": "certLib.typeCode",
  "正在从平台同步填写规则并写入本地…": "certLib.syncingRules",
  "该类型暂无平台填写模板": "certLib.noPlatformTemplate",
  "该类型暂无额外商品信息字段，可直接上传证书文件。": "certLib.noExtraFields",
  "保存到尺码库": "saveTpl.saveSize",
  "正在加载类目尺寸属性…": "sizeCreate.loadingSizeAttrs",
  "货品 ID": "marketing.enProductId",
  "建议库存": "marketing.enSuggestStock",
  "SKC，支持逗号批量": "orderList.skcPlaceholder",
  "skc信息": "marketing.enSkcInfo",
  "经营站点": "shop.colSites",
  "参考活动价": "marketing.enRefPrice",
  "参考活动库存": "marketing.enRefStock",
  "活动申报价": "marketing.enDeclare",
  "正在加载可报商品…": "marketing.enLoadingProducts",
  "请确认活动是否开放报名，或稍后再试。": "marketing.enConfirmOpen",
  "无匹配商品": "marketing.enNoMatch",
  "请调整查询条件后重试。": "marketing.enAdjustQuery",
  "加载更多中…": "marketing.enLoadingMore",
  "已选商品": "marketing.enSelected",
  "勾选后可批量报名（先选场次，再选站点）": "marketing.enBatchHintSessions",
  "勾选后可批量报名（选择站点后提交）": "marketing.enBatchHintSites",
  "自主报名": "marketing.srcSelf",
  "最长边": "publishPkg.longest",
  "次长边": "publishPkg.mid",
  "最短边": "publishPkg.shortest",
  "货品净重（必填）": "publishPkg.netReqLabel",
  "货品净重（选填）": "publishPkg.netOptLabel",
  "仅支持上传 PDF": "publishExtra.pdfOnly",
  "说明书文件需在 50MB 以内": "publishExtra.pdfSize",
  "说明书来源": "publishExtra.guideSource",
  "从尺码库选用（可选）": "sizeChartPanel.fromLibOpt",
  "加载尺码规则中…": "sizeChartPanel.loadingRules",
  "鞋码类型": "sizeChartPanel.shoeType",
  "末级属性 dependencyId 列表": "publishExtra.depIds",
  "K-type 列表": "publishExtra.ktypes",
  "车型库 relationId": "publishExtra.relationId",
  "请选择省份": "publishBasic.pickProvince",
  "部署区": "freightLib.region",
  "数量": "finance.qty",
  "请先选择店铺类型": "sizeCreate.needShopTypeFirst",
  "当前类目属性尚未加载完成": "templateEditor.attrsNotLoaded",
  "请先填写类目属性再保存到属性库": "templateEditor.fillAttrsFirst",
  "尺码表分类": "sizeChart.sizeClass",
  "主图": "imageTemplateCreate.headMain",
  "颜色": "imageTemplateCreate.colorLabel",
  "细节图": "imageTemplateCreate.headDetails",
  "本地上传": "imageSource.upload",
  "工作区": "platformNav.workspace",
  "更新码图": "designerChrome.updateCodeMap",
  "文件选择": "designerChrome.filePicker",
  "从图片空间中选择": "designerChrome.pickFromImageSpace",
  "加载颜色库…": "designerChrome.colorLibraryLoading",
  "颜色库暂无颜色": "designerChrome.colorLibraryEmpty",
  "+ 细节": "designerChrome.addDetailShort",
  "滤镜与裁剪请使用右侧「滤镜」面板，或按 C 快速裁剪为 1:1": "designerChrome.imageFilterHint",
  "请选择或输入颜色，每选一个颜色会在下方添加一行主规格上传区域": "designerChrome.colorSlotHint",
};
